<div class="modal-lg">
        <div class="form-warpper-content">
            <form>
                <div class="form-warpper-header">
                    <span class="logo"></span>
                    <span class="form-warpper-header-txt">CoinDepo</span>
                </div> <!-- .form-wrapper-header -->
                <div class="form-warpper-body">						
                    <div class="form-group form-middle">
                        <div class="custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitchPromoCode"
                            name="isShowRef"
                            [(ngModel)]="showRef"
                            (click)="setShowRefState()"
                        >
                        <label class="custom-control-label" for="customSwitchPromoCode">
                            {{ 'modals.referral.have-code' | translate }}
                        </label>
                        </div>
                    </div>
                    <div class="form-group form-middle mb-0">
                        <div class="form-control-input">
                            <input
                                type="text"
                                name="ref"
                                class="form-control form-control-placeholder"
                                [placeholder]="'modals.referral.enter-code' | translate"
                                [(ngModel)]="currentRefferal"
                                #promoCodeInput
                                [disabled]="!showRef"
                            >
                        </div>
                    </div>
                    <!-- <div class="form-check-sm custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" (click)="setRefState()" id="customPromoCode">
                    <label class="custom-control-label" for="customPromoCode">
                        {{ 'modals.referral.not-show-window-again' | translate }}
                    </label>
                    </div>				   -->
                </div> <!-- .form-wrapper-body -->
                <div class="form-warpper-footer">
                    <button
                        type="submit"
                        class="btn btn-secondary btn-lg btn-block"
                        (click)="submitCode()"
                    >
                        {{ 'shared.continue' | translate }}
                    </button>	
                    <div class="form-warpper-footer-content  mb-0">
                        <span class="form-warpper-footer-txt">
                            <a href="https://app.coindepo.com/auth/login" target="_blank">
                                {{ 'dashboard.welcome.switch-coindepo-account' | translate }}
                            </a>
                        </span>
                        <a href="https://app.coindepo.com/auth/login" target="_blank" class="form-warpper-footer-link">
                            {{ 'profile.referrals.how-it-works.text-subtitle-2' | translate }}
                        </a>
                    </div>
                </div> <!-- .form-wrapper-footer -->

            </form>
        </div> <!-- .form-wrapper-content -->

</div>